export const tooltip_municipios = f => {
  let estado = f.cvegeomun.startsWith('15') ? ' Estado: Estado de México' : 'Estado: CDMX'
  let municipio = f.cvegeomun.startsWith('09') ? 'Alcaldía: '+f.nom_mun : 'Municipio: '+f.nom_mun
  return `${estado}<br>${municipio}<br>Casos: <b>${
    f.tot_muestras == null ? 'sin dato' : f.tot_muestras
  }`; 
};
export const tooltip_cp = f => {
  return `Código postal: ${
    f.cp
  }<br>Casos: <b>${
    f.tot_muestras == null ? 'sin dato' : f.tot_muestras
  }`;
};


export class GeoJSON {
  _cabecera;
  _features;
  _features_by_id = {};
  constructor(contenido,id_column) {

    this._features = JSON.stringify(contenido.features);
    const cabecera = {...contenido};
    cabecera.features = [];
    this._cabecera = JSON.stringify(cabecera);

    if(id_column){
      this._features_by_id = contenido.features.reduce((acum,current)=>{
        if(!(current.properties[id_column] in acum)){
          acum[current.properties[id_column]] = {...current}
        }
        return acum
      },{})
    }
  }

  get contenido() {
    const contenido = JSON.parse(this._cabecera);
    contenido.features = JSON.parse(this._features);
    return contenido;
  }

  /**
  * @param {Function} accion
  */
  set filtro(accion) {
    this._filtro = accion;
  }

  get contenidoFiltrado() {
    if (typeof(this._filtro)==="function") {
      const contenido = JSON.parse(this._cabecera);
      contenido.features = JSON.parse(this._features).filter(this._filtro);
      return contenido;
    } else return this.contenido;
  }

  /**
   *
   * @param {*} callback  as Function(feature,id)
   */
  forEachFeatureById(callback){
    Object.entries(this._features_by_id).forEach(entrie=>{
      callback(entrie[1],entrie[0])
    })
  }

  setPropToFeature(idFeature,propertie,value){
    if(idFeature in this._features_by_id){
      this._features_by_id[idFeature].properties[propertie] = value
      //this._reasignarFeaturesFromFeaturesById()
    }
  }


  reasignarFeaturesFromFeaturesById(){
    const features = Object.values(this._features_by_id);
    this._features = JSON.stringify(features);

  }


}
